// Input constraints
export const INPUT_CONSTRAINTS = {
    itemCount: { min: 1, max: 100000 },
    timePerItem: { min: 0.1, max: 1440 }, // max 24 hours in minutes
    userCount: { min: 1, max: 1000 },
    hourlyRate: { min: 1, max: 1000 },
    automatedTime: { min: 0, max: 1440 },
    automationCost: { min: 1, max: 1000000 },
    timeframe: { min: 1, max: 60 }, // max 5 years in months
    maintenanceCost: { min: 0, max: 10000 },
    riskFactor: { min: 0, max: 100 }
};

export function validateInputs(inputs) {
    const errors = [];

    for (const [key, value] of Object.entries(inputs)) {
        const constraints = INPUT_CONSTRAINTS[key];
        if (constraints && (value < constraints.min || value > constraints.max)) {
            errors.push(`${key} must be between ${constraints.min} and ${constraints.max}`);
        }
    }

    return errors;
}

export function calculateROI(inputs) {
    // Time calculations
    const totalManualMinutesPerMonth = inputs.itemCount * inputs.timePerItem;
    const totalAutomatedMinutesPerMonth = inputs.itemCount * inputs.automatedTime;
    const netTimeSavedPerMonth = (totalManualMinutesPerMonth - totalAutomatedMinutesPerMonth) / 60;

    // Financial calculations - gross savings before maintenance
    const grossMonthlySavings = netTimeSavedPerMonth * inputs.hourlyRate * inputs.userCount;

    // Net monthly savings after maintenance costs
    const monthlySavings = grossMonthlySavings - inputs.maintenanceCost;
    const annualSavings = monthlySavings * 12;

    // Total costs over timeframe
    const totalMaintenanceCost = inputs.maintenanceCost * inputs.timeframe;
    const totalCost = inputs.automationCost + totalMaintenanceCost;

    // Calculate total savings and ROI
    const totalSavings = grossMonthlySavings * inputs.timeframe;
    const roi = inputs.automationCost > 0 ? ((totalSavings - totalCost) / inputs.automationCost) * 100 : 0;

    // Break-even calculation (using net monthly savings)
    const breakEvenMonths = monthlySavings > 0 ? inputs.automationCost / monthlySavings : Infinity;

    // Risk-adjusted ROI
    const riskMultiplier = (100 - inputs.riskFactor) / 100;
    const adjustedROI = roi * riskMultiplier;

    // Sensitivity Analysis
    const sensitivityAnalysis = {
        conservative: {
            roi: roi * 0.7,
            breakEven: breakEvenMonths * 1.3
        },
        moderate: {
            roi: roi,
            breakEven: breakEvenMonths
        },
        optimistic: {
            roi: roi * 1.3,
            breakEven: breakEvenMonths * 0.7
        }
    };

    return {
        totalManualMinutesPerMonth,
        totalAutomatedMinutesPerMonth,
        netTimeSavedPerMonth,
        grossMonthlySavings,
        monthlySavings,
        annualSavings,
        totalSavings,
        totalCost,
        roi,
        breakEvenMonths,
        adjustedROI,
        sensitivityAnalysis
    };
}
